import React from 'react';
import MaskedInput from 'react-text-mask';

import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';

import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { DATETIME_MASK } from '@/helpers/mask';
import Details from '@/svg-icons/details';

const UpdateAllowedAtDateComponent = ({ error, validationSchema, handleSubmit, intl }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-2 text-lg font-semibold text-[#153253] border-b pb-2">
      <Details className="size-5" />
      {intl.formatMessage({ id: 'DETAILS' })}
    </div>
    <Formik initialValues={{ allowed_at_date: '' }} onSubmit={handleSubmit} validationSchema={validationSchema}>
      {({ errors, isSubmitting, setFieldValue, values, handleBlur }) => (
        <Form className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="allowed_at_date" className="text-sm text-gray-700">
              {intl.formatMessage({ id: 'allowed_at_date' })}
            </Label>
            <MaskedInput
              mask={DATETIME_MASK}
              guide={false}
              render={(ref, props) => (
                <Input
                  {...props}
                  ref={ref}
                  id="allowed_at_date"
                  name="allowed_at_date"
                  placeholder={intl.formatMessage({ id: 'LABEL.DATETIME' })}
                  className={cn(
                    "border-gray-200 focus:border-[#5181C1] focus:ring-[#5181C1]/20",
                    (error || errors.allowed_at_date) && "border-red-500 focus:border-red-500 focus:ring-red-500/20"
                  )}
                />
              )}
              value={values.allowed_at_date}
              onChange={e => {
                setFieldValue('allowed_at_date', e.target.value);
              }}
              onBlur={handleBlur}
            />
            {(error || errors.allowed_at_date) && (
              <p className="text-xs font-medium text-red-500">
                {error || errors.allowed_at_date}
              </p>
            )}
          </div>
          <div className="flex justify-end pt-4">
            <Button 
              type="submit" 
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2"
              disabled={isSubmitting}
            >
              {intl.formatMessage({ id: 'SEND' })}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  </div>
);

UpdateAllowedAtDateComponent.propTypes = {
  error: PropTypes.string,
  validationSchema: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

UpdateAllowedAtDateComponent.defaultProps = {
  error: null,
};

export default UpdateAllowedAtDateComponent;
